export default class BlockTeam {
	static init() {

		let blocks = document.querySelectorAll('.block-team');

		blocks.forEach( (block) => {
			const swiper = block.querySelector('.swiper');
			const pagination = block.querySelector('.swiper-pagination');
			const navigationPrev = block.querySelector('.swiper-btn-prev');
			const navigationNext = block.querySelector('.swiper-btn-next');
			new Swiper(swiper, {
				slidesPerView: 1,
				breakpoints: {
					769: {
						slidesPerView: 2
					},
					992: {
						slidesPerView: 3
					}
				},
				grabCursor: true,
				spaceBetween : 30,
				navigation: {
					nextEl: navigationNext,
					prevEl: navigationPrev
				},
				pagination: {
					el: pagination,
					type: 'bullets',
					bulletElement: 'span',
					clickable: true
				},
				on: {
					init: function () {
						this.slides.forEach((slide, i) => {
							slide.style.opacity = '1';
							slide.style.pointerEvents = 'initial';
							if( i > ( this.activeIndex + this.params.slidesPerView - 1 ) ) {
								this.slides[i].style.opacity = '0';
							}
						});
					},
					slideChange: function () {
						this.slides.forEach((slide, i) => {
							slide.style.opacity = '1';
							slide.style.pointerEvents = 'initial';
							if( i > ( this.activeIndex + this.params.slidesPerView - 1 ) ) {
								this.slides[i].style.opacity = '0';
							}
						});
					}
				}
			});
		});

	}
}
